export default __webpack_public_path__ + "static/media/logo_UET.d31008e9.png";